/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refresh_Ticket_1_ContentInputs */

const en_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shop product`)
};

const ar_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ja_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ru_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const th_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const tr_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_refresh_ticket_1_content = /** @type {(inputs: Refresh_Ticket_1_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商城商品`)
};

/**
* | output |
* | --- |
* | "Shop product" |
*
* @param {Refresh_Ticket_1_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const refresh_ticket_1_content = /** @type {((inputs?: Refresh_Ticket_1_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refresh_Ticket_1_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refresh_ticket_1_content(inputs)
	if (locale === "ar") return ar_refresh_ticket_1_content(inputs)
	if (locale === "de") return de_refresh_ticket_1_content(inputs)
	if (locale === "es") return es_refresh_ticket_1_content(inputs)
	if (locale === "fr") return fr_refresh_ticket_1_content(inputs)
	if (locale === "it") return it_refresh_ticket_1_content(inputs)
	if (locale === "ja") return ja_refresh_ticket_1_content(inputs)
	if (locale === "ko") return ko_refresh_ticket_1_content(inputs)
	if (locale === "pt_br") return pt_br_refresh_ticket_1_content(inputs)
	if (locale === "ru") return ru_refresh_ticket_1_content(inputs)
	if (locale === "th") return th_refresh_ticket_1_content(inputs)
	if (locale === "tr") return tr_refresh_ticket_1_content(inputs)
	if (locale === "zh_cn") return zh_cn_refresh_ticket_1_content(inputs)
	return zh_tw_refresh_ticket_1_content(inputs)
});